import React, { useEffect, useState } from 'react'
import {
  CButton,
  CCol,
  CModal,
  CModalBody,
  CFormCheck,
  CCard,
  CCardBody,
  CFormText,
} from '@coreui/react'
import CloseIcon from '../../../assets/closeIcon.png'
import { isEmpty } from 'lodash'
import { formatBytes } from 'src/views/utils/helper'

const TrailerSelectModal = ({ data, uploadCallback, onCancel }) => {
  const [uploadFiles, setUploadFiles] = useState([])
  useEffect(() => {
    setUploadFiles(data)
  }, [data])

  const handleSubmit = () => {
    uploadCallback(uploadFiles)
  }

  const handleVideoTypeChange = (ele, value) => {
    let tempFiles = uploadFiles
    const index = tempFiles.findIndex((obj) => obj.name === ele.name && obj.size === ele.size)
    if (index > -1) {
      if (value === 'YES') {
        tempFiles[index].fileType = 'trailer'
      } else {
        tempFiles[index].fileType = 'video'
      }
    }

    setUploadFiles([...tempFiles])
  }

  return (
    <>
      <CModal
        size="lg"
        visible={true}
        alignment="center"
        className="trailer-modal"
        style={{ backgroundColor: '#707070' }}
      >
        <CModalBody className="px-4 py-4 ">
          <div style={{ fontSize: '1.5rem' }} className="d-flex justify-content-center">
            <div className="text-center">
              <p className="mb-0" style={{ fontWeight: '500' }}>
                UPLOAD FILES
              </p>
            </div>
          </div>
          <div
            className="pl-4 mx-4 d-flex justify-content-center align-items-center mt-4"
            style={{
              fontSize: '14px',
              paddingTop: '2px',
              paddingBottom: '2px ',
              zIndex: '10',
            }}
          >
            <div className="d-flex align-items-center w-100 rounded-md bg-black text-white ">
              <div style={{ width: '46%' }} className="pl-[27px]">
                File Name
              </div>
              <div style={{ width: '29%' }}>Size</div>
              <div style={{ width: '25%' }}>Save as Trailer</div>
            </div>
          </div>
          <div className="px-3 mx-4 scrollbar" style={{ maxHeight: '22rem' }}>
            {!isEmpty(uploadFiles)
              ? uploadFiles.map((info, index) => {
                  const fileName =
                    info.name.length > 40 ? info.name.slice(0, 37) + '...' : info.name
                  console.log('uploadFiles', fileName, info.fileType)
                  return (
                    <CCard
                      key={index}
                      className={`${!index ? 'mt-2' : 'my-3'} w-100`}
                      style={{
                        backgroundColor: '#ececec',
                      }}
                    >
                      <CCardBody>
                        <div className="py-1 d-flex align-items-center w-100">
                          <div className="line-clamp-1 pl-[11px]" style={{ width: '47.5%' }}>
                            {fileName}
                          </div>
                          <div className="" style={{ width: '29.6%' }}>
                            {`${formatBytes(info.size)}`}
                          </div>
                          <div className="pl-[11px]" style={{ width: '22.9%', fontSize: '14px' }}>
                            {info.fileType === 'video' || info.fileType === 'trailer' ? (
                              <div
                                className="d-flex align-items-center w-fit rounded-1 overflow-hidden"
                                style={{
                                  border: 'solid 0.5px #707070',
                                  // width: '1',
                                  fontSize: '12px',
                                }}
                              >
                                <div
                                  // className="filter-type-and-or-cformcheck"
                                  className="text-center py-2 cursor-pointer "
                                  style={{
                                    width: '63px',
                                    background: info.fileType === 'trailer' ? '#000' : '#fff',
                                    color: info.fileType === 'trailer' ? '#fff' : '#000',
                                  }}
                                  onClick={(e) => handleVideoTypeChange(info, 'YES')}
                                >
                                  YES
                                </div>
                                <div
                                  // className="filter-type-and-or-cformcheck"
                                  className=" text-center py-2 cursor-pointer"
                                  style={{
                                    width: '63px',
                                    background: info.fileType === 'video' ? '#000' : '#fff',
                                    color: info.fileType === 'video' ? '#fff' : '#000',
                                  }}
                                  onClick={(e) => handleVideoTypeChange(info, 'NO')}
                                >
                                  NO
                                </div>
                              </div>
                            ) : (
                              'N/A'
                            )}
                          </div>
                        </div>
                      </CCardBody>
                    </CCard>
                  )
                })
              : null}
          </div>
          <div
            className="d-flex justify-content-end
            pt-4 px-4"
          >
            <CButton
              className="text-white px-4 mt-3"
              style={{ fontSize: '0.9vw', background: '#20211c' }}
              onClick={handleSubmit}
            >
              SUBMIT
            </CButton>
          </div>
        </CModalBody>
      </CModal>
    </>
  )
}

export default TrailerSelectModal
